var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4998 41.8333C9.9939 41.8333 0.666504 32.5059 0.666504 21C0.666504 9.49407 9.9939 0.166672 21.4998 0.166672C33.0058 0.166672 42.3332 9.49407 42.3332 21C42.3332 32.5059 33.0058 41.8333 21.4998 41.8333ZM21.4998 39.75C31.8552 39.75 40.2498 31.3553 40.2498 21C40.2498 10.6447 31.8552 2.25001 21.4998 2.25001C11.1445 2.25001 2.74984 10.6447 2.74984 21C2.74984 31.3553 11.1445 39.75 21.4998 39.75ZM28.0549 15.0551C28.4617 14.6483 29.1213 14.6483 29.5281 15.0551C29.9349 15.4619 29.9349 16.1214 29.5281 16.5282L19.1114 26.9449C18.7046 27.3517 18.0451 27.3517 17.6383 26.9449L13.4716 22.7782C13.0648 22.3714 13.0648 21.7119 13.4716 21.3051C13.8784 20.8983 14.5379 20.8983 14.9447 21.3051L18.3748 24.7352L28.0549 15.0551Z",
    fill: "#00BC3C",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.ea7ac8a8e9f67c4af8410b895c024df1.svg";
export { ForwardRef as ReactComponent };